/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from "@atproto/lex";

const $nsid = "place.stream.multistream.target";

export { $nsid };

/** An external server for rebroadcasting a Streamplace stream */
type Main = { $type: "place.stream.multistream.target";

  /**
   * The rtmp:// or rtmps:// url of the target server.
   */
  "url":l.UriString;

  /**
   * Whether this target is currently active.
   */
  "active":boolean;

  /**
   * When this target was created.
   */
  "createdAt":l.DatetimeString;

  /**
   * A user-friendly name for this target.
   */
  "name"?:string };

export type { Main };

/** An external server for rebroadcasting a Streamplace stream */
const main = /*#__PURE__*/ l.record<"tid", Main>("tid", $nsid, /*#__PURE__*/ l.object({"url":/*#__PURE__*/ l.string({"format":"uri"}),"active":/*#__PURE__*/ l.boolean(),"createdAt":/*#__PURE__*/ l.string({"format":"datetime"}),"name":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({"maxLength":100}))}));

export { main };

export const $type = $nsid;
export const $isTypeOf = /*#__PURE__*/ main.isTypeOf.bind(main);
export const $build = /*#__PURE__*/ main.build.bind(main);
export const $assert = /*#__PURE__*/ main.assert.bind(main);
export const $check = /*#__PURE__*/ main.check.bind(main);
export const $cast = /*#__PURE__*/ main.cast.bind(main);
export const $ifMatches = /*#__PURE__*/ main.ifMatches.bind(main);
export const $matches = /*#__PURE__*/ main.matches.bind(main);
export const $parse = /*#__PURE__*/ main.parse.bind(main);
export const $safeParse = /*#__PURE__*/ main.safeParse.bind(main);
export const $validate = /*#__PURE__*/ main.validate.bind(main);
export const $safeValidate = /*#__PURE__*/ main.safeValidate.bind(main);
